<template>
    <div class="booking-page">
        <PageLoading v-model="pageLoading"></PageLoading>
        
        <!-- 预订成功页面 -->
        <div class="success-container" v-if="bookingSuccess && merInfo">
            <div class="success-content">
                <div class="success-icon">
                    <i class="el-icon-success"></i>
                </div>
                <h2 class="success-title">Booking Successful</h2>
                <p class="success-message">Your booking has been successfully submitted. We will contact you soon to confirm.</p>
                <div class="success-buttons">
                    <div class="btn btn-primary" @click="viewMerchantInfo">View Restaurant</div>
                    <div class="btn btn-secondary" @click="goBack">Back</div>
                </div>
            </div>
        </div>

        <!-- 预订流程 -->
        <div class="booking-container" v-if="merInfo && !bookingSuccess">
            <!-- 步骤指示器 -->
            <div class="step-indicator">
                <div class="step" :class="{ 'active': currentStep === 1, 'completed': currentStep > 1 }">
                    <div class="step-number">1</div>
                    <div class="step-label">Select Time</div>
                </div>
                <div class="step-line" :class="{ 'completed': currentStep > 1 }"></div>
                <div class="step" :class="{ 'active': currentStep === 2 }">
                    <div class="step-number">2</div>
                    <div class="step-label">Your Information</div>
                </div>
            </div>

            <!-- 第一步：选择时间 -->
            <div class="step-content" v-if="currentStep === 1">
                <div class="book-title">
                    <h2>Select Booking Time</h2>
                    <div class="desc-1">for</div>
                    <div class="desc-2">{{ merInfo.restaurantName }}</div>
                </div>
                
                <div class="time-selection">
                    <div class="form-line">
                        <div class="time-input-box">
                            <span class="name">Booking Time <span class="required">*</span></span>
                            <div class="input-shadow">
                                <input class="input" type="text" v-model="bookForm.bookingTime" placeholder="Select booking time" readonly>
                            </div>
                            <el-cascader class="cover-cascader" popper-class="timer-pop"
                                    v-model="bookForm.pickTime" :options="bookTimeOption" @change="handleChangeBookTime"></el-cascader>
                        </div>
                        
                        <div class="guest-input-box">
                            <span class="name">Number of Guests <span class="required">*</span></span>
                            <div class="input-shadow">
                                <input class="input" type="number" v-model="bookForm.numberGuest" placeholder="Number of guests">
                            </div>
                        </div>
                    </div>
                    
                    <div class="btn-box">
                        <div class="btn btn-cancel" @click="goBack">Cancel</div>
                        <div class="btn" @click="nextStep" :class="{'inactive-btn': !bookForm.bookingTime || !bookForm.numberGuest}">
                            Next
                        </div>
                    </div>
                </div>
            </div>

            <!-- 第二步：填写信息 -->
            <div class="step-content" v-if="currentStep === 2">
                <div class="book-title">
                    <h2>Your Information</h2>
                    <div class="desc-1">for</div>
                    <div class="desc-2">{{ merInfo.restaurantName }}</div>
                    <div class="selected-time">
                        <i class="el-icon-time"></i>
                        <span>{{ displayBookingTime }}</span>
                    </div>
                </div>
                
                <div class="book-form">
                    <div class="form-line">
                        <div class="input-box">
                            <span class="name">First Name <span class="required">*</span></span>
                            <div class="input-shadow">
                                <input class="input" type="text" v-model="bookForm.firstName" placeholder="First Name">
                            </div>
                        </div>
                        <div class="input-box">
                            <span class="name">Last Name <span class="required">*</span></span>
                            <div class="input-shadow">
                                <input class="input" type="text" v-model="bookForm.lastName" placeholder="Last Name">
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-line">
                        <div class="input-box">
                            <span class="name">Email <span class="required">*</span></span>
                            <div class="input-shadow">
                                <input class="input" type="text" v-model="bookForm.email" placeholder="Email">
                            </div> 
                        </div>
                    </div>
                    
                    <div class="form-line">
                        <div class="input-box">
                            <span class="name">Phone Number <span class="required">*</span></span>
                            <div class="phone-box">
                                <PhoneBtn v-model="bookForm.code"></PhoneBtn>
                                <input type="text" v-model="bookForm.mobile" placeholder="Phone Number">
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-line" v-if="merchantId==1397">
                        <div class="input-box">
                            <span class="name">Korean BBQ / Chinese Food</span>
                            <div class="input-shadow" style="padding: 10px;">
                                <el-radio v-model="foodTypeDesc" border size="medium" label="Korean BBQ">Korean BBQ</el-radio>
                                <el-radio v-model="foodTypeDesc" border size="medium" label="Chinese Food">Chinese Food</el-radio>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-line" v-if="merInfo && merInfo.tableNumberFlag == 1">
                        <div class="input-box">
                            <span class="name">Table Number <span class="required">*</span></span>
                            <div class="input-shadow">
                                <input class="input" type="text" v-model="bookForm.tableNumber" placeholder="Your Table Number">
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-line">
                        <div class="input-box">
                            <span class="name">Booking Note</span>
                            <div class="input-shadow">
                                <el-input class="input-textarea" type="textarea" placeholder="Add note..." rows="4" v-model="bookForm.bookingNotes" maxlength="300" show-word-limit></el-input>
                            </div>
                        </div>
                    </div>

                    <div class="btn-box">
                        <div class="btn btn-cancel" @click="prevStep">Back</div>
                        <div class="btn" @click="confirmBook" :class="{'inactive-btn': !bookForm.firstName || !bookForm.lastName || !bookForm.email || !bookForm.mobile || (merInfo && merInfo.tableNumberFlag == 1 && !bookForm.tableNumber)}">
                            <i class="el-icon-loading" v-if="bookLoading"></i>
                            <span v-else>Submit</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-else class="loading-container">
            <p>Loading...</p>
        </div>
    </div>
</template>

<script>
import { postGateway } from "@/request/index.js";
import PhoneBtn from "@/components/PhoneBtn.vue";
import PageLoading from "@/components/PageLoading.vue";

export default {
    name: 'Book',
    components: {
        PhoneBtn,
        PageLoading
    },
    data() {
        return {
            slug: '',
            merchantId: null,
            merInfo: null,
            pageLoading: false,
            bookLoading: false,
            bookingSuccess: false,
            currentStep: 1, // 当前步骤
            foodTypeDesc: '',
            tableBookMultiSelector: [],
            bookForm: {
                clientId: localStorage.getItem('clientId'),
                code: (this.$isUk?'+44':'+353'),
                bookingName: '',  //预定人名称
                mobile: '',
                email: '',
                bookingNotes: '', // 备注
                numberGuest: '', // 预定人数
                bookingTime: '', // 预定时间
                pickTime: [], // 级联选择器的值
                merchantName: '',
                merchantId: '',
                firstName: '', // 名字
                lastName: '', // 姓氏
                tableNumber: '', // 桌号
            }
        }
    },
    computed: {
        bookTimeOption() {  // 订桌时间选择器选项
            let list = [...this.tableBookMultiSelector];
            return list
        },
        // 格式化显示时间
        displayBookingTime() {
            if (!this.bookForm.bookingTime) return '';
            
            // 将年/月/日格式转换为日/月/年格式用于显示
            const parts = this.bookForm.bookingTime.split(' ');
            if (parts.length === 2) {
                const [date, time] = parts;
                const [year, month, day] = date.split('/');
                return `${day}/${month}/${year} ${time}`;
            }
            return this.bookForm.bookingTime;
        }
    },
    mounted() {
        console.log('Booking page mounted');
        this.initMerchant();
    },
    methods: {
        // 初始化商家信息
        initMerchant() {
            let slug = this.$route.params.pathMatch;
            this.slug = slug;
            if(this.slug.includes('/')) {
                this.slug = this.slug.replace(/\//g,'')
            }

            this.pageLoading = true;
            this.getMerchantId(this.slug).then(()=>{
                this.getMerchantInfo().then(()=>{
                    this.initTableBookTime();
                });
            })
            .catch((err)=>{
                this.pageLoading = false;
                console.log('获取商家信息失败:', err);
            })
        },
        // 根据slug获取商家ID
        getMerchantId(slug) {
            console.log(slug,'请求参数的 slug')
            return postGateway({
                url: "/customerWeb/merchantDetail/getMerchantBySlug",
                method: "GET",
                data: {
                    slug
                }
            }).then(res=>{
                this.merchantId = res.data*1
            })
        },
        // 获取商家详细信息
        getMerchantInfo() {
            let param = {
                merchantId: this.merchantId,
                type: 3, // dinein类型
            }
            return postGateway({
                url: '/customerApp/merchantDetail/getMerchantDetail',
                method: 'GET',
                data: param
            })
            .then(res=>{
                this.merInfo = res.data
                this.pageLoading = false;
                console.log('商家信息获取成功:', this.merInfo);
            })
            .catch((err)=>{
                this.pageLoading = false;
                console.log('获取商家详情失败:', err);
            })
        },
        // 初始化预订时间选择器
        initTableBookTime() {
            postGateway({
                url: '/merchant/merchantOperateTime/getMerchantOrderTime',
                method: 'GET',
                data: {
                    merchantId: this.merchantId,
                    type: 'dinein'
                }
            })
            .then(({data})=>{
                let res = data;
                this.tableBookMultiSelector = res;
                console.log(this.tableBookMultiSelector,'处理后的结果预订时间选择');
            })
            .catch(err=>{
                console.log(err, '获取预订时间失败');
            })
        },
        // 修改预约时间
        handleChangeBookTime(val) {
            let [date, time] = val;
            let dateStr;
            if(date) {
                let [year, mon, day] = date.split('-');
                dateStr = `${year}/${mon}/${day}`
            }
            this.bookForm.bookingTime = dateStr + ' ' + time;
            console.log(this.bookForm.bookingTime, 'booking time');
        },
        // 下一步
        nextStep() {
            if (!this.bookForm.bookingTime) {
                this.$message.warning('Please select a booking time');
                return;
            }
            if (!this.bookForm.numberGuest) {
                this.$message.warning('Please enter number of guests');
                return;
            }
            this.currentStep = 2;
        },
        // 上一步
        prevStep() {
            this.currentStep = 1;
        },
        // 表单验证
        judgeRequired() {
            for (let key in this.bookForm) {
                if(!this.bookForm[key] && key != 'clientId' && key != 'pickTime' && key != 'bookingNotes' && key != 'bookingName') {
                    // 如果商家需要桌号但桌号为空，返回false
                    if(key == 'tableNumber' && this.merInfo && this.merInfo.tableNumberFlag == 1) {
                        return false;
                    }
                    // 如果商家不需要桌号，跳过桌号验证
                    if(key == 'tableNumber' && (!this.merInfo || this.merInfo.tableNumberFlag != 1)) {
                        continue;
                    }
                    return false;
                }
            }
            return true
        },
        // 确认预约
        confirmBook() {
            if(this.bookLoading) return
            
            // 拼接姓名
            this.bookForm.bookingName = this.bookForm.firstName + ' ' + this.bookForm.lastName;
            
            this.bookForm.merchantName = this.merInfo.restaurantName;
            this.bookForm.merchantId = this.merInfo.merchantId;

            // 检验输入框
            if(!this.judgeRequired()) {
                this.$message.warning('Please check your form');
                console.log(this.bookForm, 'bookForm');
                return
            }

            if(this.merchantId == 1397 && !this.foodTypeDesc) {
                this.$message.warning('Please choose Korean BBQ or Chinese Food');
                return
            }

            if(this.merInfo && this.merInfo.tableNumberFlag == 1 && !this.bookForm.tableNumber) {
                this.$message.warning('Please enter your table number');
                return
            }

            this.bookLoading = true;
            let param = {
                ...this.bookForm,
                clientId: localStorage.getItem('clientId'),
                merchantName: this.merInfo.restaurantName,
                merchantId: this.merInfo.merchantId,
                mobile: this.bookForm.code + this.bookForm.mobile
            }

            if(this.foodTypeDesc) {
                param.bookingNotes = this.foodTypeDesc + '; ' + param.bookingNotes;
            }

            if(this.$route.query.rwg_token) {
                param.rwg_token = this.$route.query.rwg_token;
            }
            
            console.log(param,'booking param');

            postGateway({
                url: '/merchant/bookingTable/appAdd',
                data: {
                    ...param
                }
            }).then(res=>{
                console.log(res,'booking success');
                this.bookLoading = false;
                this.bookingSuccess = true;
                // this.$message.success('Booking Success!');
            })
            .catch(err=>{
                this.bookLoading = false;
                this.$message.error('Booking failed, please try again');
                console.log(err,'预定报错');
            })
        },
        // 返回上一页
        goBack() {
            this.$router.push({
                path: '/menu-'+this.slug,
            })
        },
        // 查看商家信息
        viewMerchantInfo() {
            this.$router.push(`/menu-${this.slug}`);
        }
    }
}
</script>

<style lang="scss" scoped>
.booking-page {
    min-height: 100vh;
    background: #ffffff;
    padding: 20px;
    font-family: 'Source Sans Pro', sans-serif;
}

.success-container {
    background: #fff;
    border-radius: 30px;
    padding: 50px 35px;
    box-shadow: 0px 5px 8px #bbc4c7;
    max-width: 600px;
    margin: 0 auto;
    text-align: center;
    
    .success-content {
        .success-icon {
            font-size: 80px;
            color: #09CA6A;
            margin-bottom: 20px;
            
            i {
                font-size: 80px;
            }
        }
        
        .success-title {
            font-size: 32px;
            font-weight: 700;
            color: #000;
            margin: 0 0 15px 0;
        }
        
        .success-message {
            font-size: 16px;
            color: #666;
            margin-bottom: 30px;
            line-height: 1.5;
        }
        
        .success-buttons {
            display: flex;
            gap: 15px;
            justify-content: center;
            flex-wrap: wrap;
            
            .btn {
                padding: 12px 30px;
                border-radius: 8px;
                font-size: 16px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;
                border: none;
                min-width: 120px;
                
                &.btn-primary {
                    background: #09CA6A;
                    color: #fff;
                    
                    &:hover {
                        background: #08b85e;
                    }
                }
                
                &.btn-secondary {
                    background: #f5f5f5;
                    color: #666;
                    
                    &:hover {
                        background: #e9e9e9;
                    }
                }
            }
        }
    }
}

.booking-container {
    background: #fff;
    border-radius: 30px;
    padding: 35px;
    box-shadow: 0px 5px 8px #bbc4c7;
    max-width: 600px;
    margin: 0 auto;
}

// 步骤指示器样式
.step-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    
    .step {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        
        .step-number {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: #e9e9e9;
            color: #666;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 16px;
            transition: all 0.3s ease;
            margin-bottom: 8px;
        }
        
        .step-label {
            font-size: 14px;
            color: #666;
            font-weight: 500;
            text-align: center;
        }
        
        &.active {
            .step-number {
                background: #09CA6A;
                color: #fff;
            }
            
            .step-label {
                color: #09CA6A;
                font-weight: 600;
            }
        }
        
        &.completed {
            .step-number {
                background: #09CA6A;
                color: #fff;
            }
            
            .step-label {
                color: #09CA6A;
            }
        }
    }
    
    .step-line {
        width: 60px;
        height: 2px;
        background: #e9e9e9;
        margin: 0 20px;
        margin-bottom: 8px;
        transition: all 0.3s ease;
        
        &.completed {
            background: #09CA6A;
        }
    }
}

.step-content {
    .book-title {
        color: #000;
        font-family: 'Source Sans Pro', sans-serif;
        text-align: center;
        margin-bottom: 30px;
        
        h2 {
            font-weight: 700;
            font-size: 28px;
            margin: 0 0 8px;
            color: #000;
        }
        
        .desc-1 {
            font-size: 16px;
            color: #939393;
            margin-bottom: 4px;
        }
        
        .desc-2 {
            font-size: 18px;
            color: #000;
            font-weight: 600;
            margin-bottom: 8px;
        }
        
        .selected-time {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #09CA6A;
            font-size: 16px;
            font-weight: 600;
            
            i {
                margin-right: 8px;
                font-size: 18px;
            }
        }
    }
}

.time-selection {
    .form-line {
        display: flex;
        gap: 20px;
        margin-bottom: 30px;
        
        .time-input-box {
            flex: 1;
            position: relative;
            cursor: pointer;
            
            .cover-cascader {
                opacity: 0;
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 100%;
                z-index: 10;
            }
            
            .name {
                font-size: 14px;
                color: #000;
                font-weight: 600;
                display: block;
                margin-bottom: 6px;
                
                .required {
                    color: #e74c3c;
                    margin-left: 2px;
                }
            }
            
            .input-shadow {
                box-shadow: 0px 2px 8px rgba(16, 16, 16, 0.1);
                border-radius: 8px;
                overflow: hidden;
                transition: all 0.3s ease;
                
                &:hover {
                    box-shadow: 0px 3px 12px rgba(16, 16, 16, 0.15);
                }
                
                &:focus-within {
                    box-shadow: 0px 3px 12px rgba(9, 202, 106, 0.25);
                }
            }
            
            .input {
                padding: 12px 16px;
                height: 44px;
                width: 100%;
                border: 1px solid #e9e9e9;
                border-radius: 8px;
                font-size: 14px;
                color: #000;
                background: #fff;
                transition: all 0.3s ease;
                
                &:focus {
                    outline: none;
                    border-color: #09CA6A;
                    background: #fff;
                }
                
                &::placeholder {
                    color: #939393;
                }
            }
        }
        
        .guest-input-box {
            flex: 1;
            position: relative;
            
            .name {
                font-size: 14px;
                color: #000;
                font-weight: 600;
                display: block;
                margin-bottom: 6px;
                
                .required {
                    color: #e74c3c;
                    margin-left: 2px;
                }
            }
            
            .input-shadow {
                box-shadow: 0px 2px 8px rgba(16, 16, 16, 0.1);
                border-radius: 8px;
                overflow: hidden;
                transition: all 0.3s ease;
                
                &:hover {
                    box-shadow: 0px 3px 12px rgba(16, 16, 16, 0.15);
                }
                
                &:focus-within {
                    box-shadow: 0px 3px 12px rgba(9, 202, 106, 0.25);
                }
            }
            
            .input {
                padding: 12px 16px;
                height: 44px;
                width: 100%;
                border: 1px solid #e9e9e9;
                border-radius: 8px;
                font-size: 14px;
                color: #000;
                background: #fff;
                transition: all 0.3s ease;
                
                &:focus {
                    outline: none;
                    border-color: #09CA6A;
                    background: #fff;
                }
                
                &::placeholder {
                    color: #939393;
                }
            }
        }
    }
    
    .btn-box {
        display: flex;
        justify-content: space-between;
        margin-top: 24px;
        gap: 12px;
        
        .btn {
            height: 44px;
            min-width: 100px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s ease;
            border: none;
            
            &:not(.btn-cancel) {
                background: #09CA6A;
                color: #fff;
                flex: 1;
                
                &:hover {
                    background: #06a85a;
                    transform: translateY(-1px);
                }
                
                &.inactive-btn {
                    background: #ecebeb;
                    color: #333;
                    cursor: not-allowed;
                    transform: none;
                    
                    &:hover {
                        background: #c4c4c4;
                        transform: none;
                    }
                }
            }
        }
        
        .btn-cancel {
            border: 1px solid #e74c3c;
            background: #fff;
            color: #e74c3c;
            min-width: 120px;
            
            &:hover {
                background: #e74c3c;
                color: #fff;
                transform: translateY(-1px);
            }
        }
    }
}

.book-form {
    .form-line {
        display: flex;
        margin-top: 20px;
        gap: 20px;
        
        &:first-child {
            margin-top: 0;
        }
        
        .input-box {
            flex: 1;
            position: relative;
            
            .cover-cascader {
                opacity: 0;
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 100%;
                z-index: 10;
            }
            
            .name {
                font-size: 14px;
                color: #000;
                font-weight: 600;
                display: block;
                margin-bottom: 6px;
                
                .required {
                    color: #e74c3c;
                    margin-left: 2px;
                }
            }
            
            .input-shadow {
                box-shadow: 0px 2px 8px rgba(16, 16, 16, 0.1);
                border-radius: 8px;
                overflow: hidden;
                transition: all 0.3s ease;
                
                &:hover {
                    box-shadow: 0px 3px 12px rgba(16, 16, 16, 0.15);
                }
                
                &:focus-within {
                    box-shadow: 0px 3px 12px rgba(9, 202, 106, 0.25);
                }
            }
            
            .input {
                padding: 12px 16px;
                height: 44px;
                width: 100%;
                border: 1px solid #e9e9e9;
                border-radius: 8px;
                font-size: 14px;
                color: #000;
                background: #fff;
                transition: all 0.3s ease;
                
                &:focus {
                    outline: none;
                    border-color: #09CA6A;
                    background: #fff;
                }
                
                &::placeholder {
                    color: #939393;
                }
            }
            
            .input-textarea {
                :deep(.el-textarea__inner) {
                    border: 1px solid #e9e9e9;
                    font-size: 14px;
                    color: #000;
                    padding: 12px 16px;
                    border-radius: 8px;
                    resize: none;
                    
                    &:focus {
                        border-color: #09CA6A;
                        background: #fff;
                    }
                }
            }
            
            .phone-box {
                display: flex;
                align-items: center;
                border: 1px solid #e9e9e9;
                height: 44px;
                border-radius: 8px;
                background: #fff;
                overflow: hidden;
                transition: all 0.3s ease;
                
                &:hover {
                    border-color: #ccc;
                }
                
                &:focus-within {
                    border-color: #09CA6A;
                }
                
                input {
                    flex: 1;
                    padding: 0 12px;
                    border: none;
                    color: #000;
                    font-size: 14px;
                    height: 100%;
                    
                    &:focus {
                        outline: none;
                    }
                    
                    &::placeholder {
                        color: #939393;
                    }
                }
            }
        }
    }
    
    .btn-box {
        display: flex;
        justify-content: space-between;
        margin-top: 24px;
        gap: 12px;
        
        .btn {
            height: 44px;
            min-width: 100px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s ease;
            border: none;
            
            &:not(.btn-cancel) {
                background: #09CA6A;
                color: #fff;
                flex: 1;
                
                &:hover {
                    background: #06a85a;
                    transform: translateY(-1px);
                }
                
                &.inactive-btn {
                    background: #939393;
                    color: #fff;
                    cursor: not-allowed;
                    transform: none;
                    
                    &:hover {
                        background: #939393;
                        transform: none;
                    }
                }
            }
        }
        
        .btn-cancel {
            border: 1px solid #e74c3c;
            background: #fff;
            color: #e74c3c;
            min-width: 80px;
            
            &:hover {
                background: #e74c3c;
                color: #fff;
                transform: translateY(-1px);
            }
        }
    }
}

.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50vh;
    
    p {
        font-size: 18px;
        color: #fff;
        font-weight: 600;
    }
}

// 响应式设计
@media screen and (max-width: 950px) {
    .booking-page {
        padding: 15px;
        background: #e7e6e6;
    }
    
    .success-container {
        width: 95%;
        padding: 30px 20px;
        box-shadow: unset;
        
        .success-content {
            .success-icon {
                font-size: 60px;
                margin-bottom: 15px;
                
                i {
                    font-size: 60px;
                }
            }
            
            .success-title {
                font-size: 24px;
                margin-bottom: 12px;
            }
            
            .success-message {
                font-size: 14px;
                margin-bottom: 25px;
            }
            
            .success-buttons {
                flex-direction: column;
                gap: 10px;
                
                .btn {
                    width: 100%;
                    padding: 12px 20px;
                    font-size: 14px;
                    min-width: unset;
                }
            }
        }
    }
    
    .booking-container {
        width: 95%;
        padding: 20px 15px;
        box-shadow: unset;
    }
    
    .step-indicator {
        margin-bottom: 20px;
        
        .step {
            .step-number {
                width: 35px;
                height: 35px;
                font-size: 14px;
            }
            
            .step-label {
                font-size: 12px;
            }
        }
        
        .step-line {
            width: 40px;
            margin: 0 15px;
        }
    }
    
    .step-content {
        .book-title {
            margin-bottom: 20px;
            
            h2 {
                font-size: 22px;
            }
            
            .desc-1 {
                font-size: 14px;
            }
            
            .desc-2 {
                font-size: 16px;
            }
            
            .selected-time {
                font-size: 14px;
            }
        }
    }
    
    .time-selection {
        .form-line {
            flex-direction: column;
            gap: 0;
            margin-bottom: 20px;
            
            .time-input-box {
                margin-bottom: 12px;
                
                .input {
                    height: 40px;
                    padding: 10px 12px;
                    font-size: 13px;
                }
            }
            
            .guest-input-box {
                margin-bottom: 0;
                
                .input {
                    height: 40px;
                    padding: 10px 12px;
                    font-size: 13px;
                }
            }
        }
        
        .btn-box {
            flex-direction: column-reverse;
            gap: 10px;
            margin-top: 20px;
            
            .btn {
                min-height: 44px;
                height: 44px;
                font-size: 14px;
                font-weight: bold;
            }
        }
    }
    
    .book-form {
        .form-line {
            flex-direction: column;
            gap: 0;
            margin-top: 16px;
            
            &:first-child {
                margin-top: 0;
            }
            
            .input-box {
                margin-left: 0 !important;
                width: 100% !important;
                margin-top: 12px;
                
                &:first-child {
                    margin-top: 0;
                }
                
                .name {
                    font-size: 13px;
                }
                
                .input {
                    height: 40px;
                    padding: 10px 12px;
                    font-size: 13px;
                }
                
                .phone-box {
                    height: 40px;
                    
                    input {
                        padding: 0 10px;
                        font-size: 13px;
                    }
                }
                
                .input-textarea {
                    :deep(.el-textarea__inner) {
                        padding: 10px 12px;
                        font-size: 13px;
                    }
                }
            }
        }
        
        .btn-box {
            flex-direction: column-reverse;
            gap: 10px;
            margin-top: 20px;
            
            .btn {
                min-height: 44px;
                height: 44px;
                font-size: 14px;
                font-weight: bold;
            }
        }
    }
}

// Element UI 样式覆盖
:deep(.el-cascader) {
    width: 100%;
}

:deep(.el-radio) {
    margin-right: 16px;
    
    &:last-child {
        margin-right: 0;
    }
}

:deep(.el-radio.is-bordered) {
    border-radius: 8px;
    padding: 8px 16px;
    transition: all 0.3s ease;
    
    &:hover {
        border-color: #09CA6A;
    }
    
    &.is-checked {
        border-color: #09CA6A;
        background-color: rgba(9, 202, 106, 0.1);
    }
}

:deep(.timer-pop) {
    .el-cascader-panel {
        .el-cascader-node {
            &:hover {
                background-color: rgba(9, 202, 106, 0.1);
            }
            
            &.is-active {
                background-color: rgba(9, 202, 106, 0.2);
                color: #09CA6A;
            }
        }
    }
}
</style>